import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EditSampleComponent } from 'app/components/well/samples/edit/edit-samples.component';
import { VoucherReport } from 'app/models/vouchers/voucher-report';
import { VoucherService } from 'app/services/voucher-service';
import { ToastrService } from 'ngx-toastr';
import { DialogEditVoucherComponent } from '../../edit/voucher-edit-dialog';

@Component({
  selector: 'voucher-exceedance-not-indicated-report',
  templateUrl: './voucher-exceedance-not-indicated.html',
  styleUrls: ['./voucher-exceedance-not-indicated.scss']
})
export class VoucherExceedanceNotIndicatedReportComponent implements OnInit {
  loading: boolean = false;
  voucherReport: VoucherReport[] = [];

  displayedColumns: string[] = ['voucherId','applicationType','sampleId', 'analyte', 'result', 'unit'];
  dataSource = new MatTableDataSource<VoucherReport>(this.voucherReport);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(private voucherService: VoucherService,
    public dialog: MatDialog,
    private toastr: ToastrService ) { 
  }

  ngOnInit(): void {
    this.loadReport();
  }

  editSample(sampleId: number) {
    const dialogRef = this.dialog.open(EditSampleComponent, {
      width: '90%',
      data: sampleId
    });
    dialogRef.afterClosed().subscribe(result => {
        this.loadReport();
    });
  }

  editVoucher(voucherId: number) {
    const dialogRef = this.dialog.open(DialogEditVoucherComponent, {
      width: '90%',
      data: voucherId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadReport();
    });
  }
  
  loadReport() {
    this.loading = true;

    this.voucherService.getVoucherExceedanceNotIndicatedReport().subscribe(
      result => {
        this.voucherReport = result;
        
        this.loading = false;
      },
      error => {
        this.toastr.error(error.message)
        this.loading = false;
      },
      () => {
        this.dataSource = new MatTableDataSource<VoucherReport>(this.voucherReport);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }
}